<template>
    <div class="change-password-container">
        <div class="row mx-0">
            <div class="offset-md-1 col-md-6 px-0">
                <reset-password-instructions />
            </div>
            <div class="col-md-5 px-0 faq-container">
                <reset-password-faq />
            </div>
        </div>
    </div>
</template>

<script>
    import ResetPasswordFaq from "@/components/ResetPasswordFaq.vue";
    import ResetPasswordInstructions from "@/components/ResetPasswordInstructions";

    export default {
        name: 'ResetPasswordBody',
        components: {
            ResetPasswordFaq,
            ResetPasswordInstructions,
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .change-password-container {
        background:#ffffff;
        line-height: normal;
    }

    @media (max-width: 750px) {
        .change-password-faq{
            min-width: 100%;
        }
    }

    @media (max-width: 400px) {
        .change-password-faq {
            margin-bottom: 20px;
        }
    }

    .faq-container{
      background-color: #F1F1F1;
    }
</style>
